const serviceUrl = `${__configuration.apiUrl}/massia/gestion/inerte-registre`;

export default class InerteRegistreAdmissionService {
	static $inject = ['$http'];

	constructor($http) {
		this.$http = $http;
	}

	async export(idSiteCommercial, idsSiteClient, debut, fin, fileName) {
		const filtres = {
			idSiteCommercial: idSiteCommercial,
			idsSiteClient: idsSiteClient,
			debut: debut,
			fin: fin,
			fileName: fileName
		};
		let res = await this.$http.post(serviceUrl, filtres, {
			responseType: 'arraybuffer'
		});

		return res;
	}

	async getSiteCommercials() {
		const url = `${__configuration.apiUrl}/massia/sites-commerciaux/headers`;
		const res = await this.$http.get(url);
		return res.data;
	}

	async getSiteClients(idSociete) {
		const url = `${__configuration.apiUrl}/massia/sites-clients/header/${idSociete}`;
		const res = await this.$http.get(url);
		return res.data;
	}
}
